import { NotificationDto } from '@timechef/core/api/models/notification-dto';

export interface NotificationsByPeriod {
  period: NotificationsPeriodEnum;
  items: NotificationDto[];
}

export enum NotificationsPeriodEnum {
  Today = 'Today',
  Yesterday = 'Yesterday',
  Previously = 'Previously',
}

export interface PageInfo {
  hasMore: boolean;
  currentPageIndex: number;
}

export interface PageInfoWithData<T> extends PageInfo {
  data: T[];
}
